// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_b2-0";